// extracted by mini-css-extract-plugin
export default {"heading":"CollectiveInvoices_Details_heading__W7JDv","actions":"CollectiveInvoices_Details_actions__HKjP0"};